import headful from "headful";

export default {
    data() {
        return {
            generalMetaProperties: {
                type: "website",
                locale: "en_US",
                twitterAccount: "@hibooksapp",
                twitterCard: "summary_large_image"
            },
            insightsMetaProperties: {
                title: "Insights: Powerful ideas from the world's best nonfiction",
                description: "Welcome to Insights - Book Insights deliver key takeaways and expert commentary from nonfiction classics and bestsellers in 30 minutes a day.",
                facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
                siteName: "hibooks Insights"
            },
            audiobooksMetaProperties: {
                title: "hibooks: The club for audiobook lovers",
                description: "Welcome to hibooks - the next chapter of your audiobook experience! Enjoy over 100 thousand audiobooks! Including unlimited access to 5 thousand plus!",
                keywords: "hibooks, audiobooks, books, book store, coins, coin bundles, pay with subscription, subscription, book collections, best seller",
                siteName: "hibooks"
            }
        }
    },
    watch: {
        "$route": {
            handler() {
                headful({
                    url: this.canonicalUrl
                });
            },
            immediate: true
        }
    },
    computed: {
        insightsImageUrl() {
            const socialShareImageUrl = "img/book-insights/social-share-img.png";
            return `${process.env.VUE_APP_DOMAIN}/${socialShareImageUrl}`;
        },
        canonicalUrl() {
            return `${process.env.VUE_APP_DOMAIN}${this.$route.path}`;
        },
        insightsMetaInfo() {
            return {
                title: this.insightsMetaProperties.title,
                meta: [
                    {
                        hid: "description",
                        name: "description",
                        content: this.insightsMetaProperties.description,
                        vmid: "description"
                    },
                    {
                        hid: "og:description",
                        name: "og:description",
                        content: this.insightsMetaProperties.description,
                        vmid: "og:description"
                    },
                    {
                        hid: "og:title",
                        name: "og:title",
                        content: this.insightsMetaProperties.title,
                        vmid: "og:title"
                    },
                    {
                        hid: "og:image",
                        name: "og:image",
                        content: this.insightsImageUrl,
                        vmid: "og:image"
                    },
                    {
                        hid: "og:url",
                        name: "og:url",
                        content: this.canonicalUrl,
                        vmid: "og:url"
                    },
                    {
                        hid: "og:type",
                        name: "og:type",
                        content: this.generalMetaProperties.type,
                        vmid: "og:type"
                    },
                    {
                        hid: "og:site_name",
                        name: "og:site_name",
                        content: this.insightsMetaProperties.siteName,
                        vmid: "og:site_name"
                    },
                    {
                        hid: "twitter:description",
                        name: "twitter:description",
                        content: this.insightsMetaProperties.description,
                        vmid: "twitter:description"
                    },
                    {
                        hid: "twitter:title",
                        name: "twitter:title",
                        content: this.insightsMetaProperties.title,
                        vmid: "twitter:title"
                    },
                    {
                        hid: "twitter:site",
                        name: "twitter:site",
                        content: this.generalMetaProperties.twitterAccount,
                        vmid: "twitter:site"
                    },
                    {
                        hid: "fb:app_id",
                        name: "fb:app_id",
                        content: this.insightsMetaProperties.facebookAppId,
                        vmid: "fb:app_id"
                    },
                    {
                        hid: "twitter:card",
                        name: "twitter:card",
                        content: this.generalMetaProperties.twitterCard,
                        vmid: "twitter:card"
                    }
                ]
            }
        },
        audiobooksMetaInfo() {
            return {
                title: "hibooks: The club for audiobook lovers",
                meta: [
                    {
                        hid: "description",
                        name: "description",
                        content: this.audiobooksMetaProperties.description,
                        vmid: "description"
                    },
                    {
                        hid: "og:description",
                        name: "og:description",
                        content: this.audiobooksMetaProperties.description,
                        vmid: "og:description"
                    },
                    {
                        hid: "og:title",
                        name: "og:title",
                        content: this.audiobooksMetaProperties.title,
                        vmid: "og:title"
                    },
                    {
                        hid: "og:site_name",
                        name: "og:site_name",
                        content: this.audiobooksMetaProperties.siteName,
                        vmid: "og:site_name"
                    },
                    {
                        hid: "twitter:description",
                        name: "twitter:description",
                        content: this.audiobooksMetaProperties.description,
                        vmid: "twitter:description"
                    },
                    {
                        hid: "twitter:title",
                        name: "twitter:title",
                        content: this.audiobooksMetaProperties.title,
                        vmid: "twitter:title"
                    },
                    {
                        hid: "keywords",
                        name: "keywords",
                        content: this.audiobooksMetaProperties.keywords,
                        vmid: "keywords"
                    },
                    {
                        hid: "og:type",
                        name: "og:type",
                        content: this.generalMetaProperties.type,
                        vmid: "og:type"
                    },
                    {
                        hid: "og:url",
                        name: "og:url",
                        content: this.canonicalUrl,
                        vmid: "og:url"
                    },
                    {
                        hid: "og:locale",
                        name: "og:locale",
                        content: this.generalMetaProperties.locale,
                        vmid: "og:locale"
                    },
                    {
                        hid: "twitter:card",
                        name: "twitter:card",
                        content: this.generalMetaProperties.twitterCard,
                        vmid: "twitter:card"
                    }
                ]
            }
        }
    },
    metaInfo() {
        return this.$route.meta.group === "nonfiction" ? this.insightsMetaInfo : this.audiobooksMetaInfo;
    }
}
